import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    attrs: {
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c("path", {
    attrs: {
      "d": "M20.25 13.75a.75.75 0 0 1 .102 1.493l-.102.007h-3.94l4.47 4.47a.75.75 0 0 1-.976 1.133l-.084-.073-4.471-4.47.001 3.94a.75.75 0 0 1-.648.742L14.5 21a.75.75 0 0 1-.743-.648l-.007-.102v-5.765c0-.02.002-.041.004-.061l-.004.077a.754.754 0 0 1 .304-.603l-.084.073a.753.753 0 0 1 .428-.213l.102-.007h5.75ZM9.5 3a.75.75 0 0 1 .744.648l.007.102V9.518c0 .02-.002.04-.004.06l.004-.077a.754.754 0 0 1-.301.601l.081-.07a.753.753 0 0 1-.428.212l-.102.007H3.75a.75.75 0 0 1-.102-1.493l.102-.007H7.69l-4.47-4.47a.75.75 0 0 1 .976-1.134l.084.073 4.47 4.469V3.75a.75.75 0 0 1 .65-.743L9.5 3Z"
    }
  })]);
};
var MinscreenLeft = {
  render
};
var index = function index2() {
  return svg({
    name: "IconMinscreenLeft",
    component: MinscreenLeft
  })();
};
export {
  index as default
};
